import { render, staticRenderFns } from "./ClinicDepositReport.vue?vue&type=template&id=a84ac66a&scoped=true"
import script from "./ClinicDepositReport.vue?vue&type=script&lang=js"
export * from "./ClinicDepositReport.vue?vue&type=script&lang=js"
import style0 from "./ClinicDepositReport.vue?vue&type=style&index=0&id=a84ac66a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a84ac66a",
  null
  
)

export default component.exports